import { render, staticRenderFns } from "./MapSwitchButton.vue?vue&type=template&id=26a34218&scoped=true&"
import script from "./MapSwitchButton.vue?vue&type=script&lang=js&"
export * from "./MapSwitchButton.vue?vue&type=script&lang=js&"
import style0 from "./MapSwitchButton.vue?vue&type=style&index=0&id=26a34218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a34218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26a34218')) {
      api.createRecord('26a34218', component.options)
    } else {
      api.reload('26a34218', component.options)
    }
    module.hot.accept("./MapSwitchButton.vue?vue&type=template&id=26a34218&scoped=true&", function () {
      api.rerender('26a34218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Map/components/mapbox/MapSwitchButton.vue"
export default component.exports